class ProductUpsellPDP extends HTMLElement {
  constructor() {
    super();
    this.productContainer = document.querySelector(".product-container");
    this.atcBtn = document.querySelector(`.product-container button[name="add"]`);
    this.originalVariantIdElement = document.querySelector(`.product-container input[name="id"]`);
    this.originalQuantityInput = document.querySelector(`.product-container input[name="quantity"]`);
    this.originalOptionSelector = document.querySelector(".block-product-variant-picker");
    this.originalProductPrice = document.querySelector(".block-product-price [data-price-formatted] > div.d-none span:not(.visually-hidden)");
    this.originalProductJson = JSON.parse(this.querySelector(`script[data-original-product-json]`).textContent);

    this.selectedOptions = [];
    this.upsellProductJson = JSON.parse(this.querySelector(`script[data-upsell-product-json]`).textContent);
    this.upsellContainer = document.querySelector(".product-upsell-wrapper");
    this.selectOption = this.querySelector("#upsell-product-variants");
    this.productOptions = this.querySelectorAll("input");
    this.regularPrice = this.querySelector(".price__regular");
    this.comparePrice = this.querySelector(".price__compare");

    this.originalVariantId = this.originalVariantIdElement.value;
    this.upsellVariantId = this.upsellProductJson.variants[0].id;

    this.repositionComponent();
    this.buildOriginalOptionSelector();
    this.variantChangeListener();
    this.upsellSelectHandler();
    this.optionInputClickHandler();
    this.updateOrigianlPriceOnVariantChange();
  }

  repositionComponent() {
    if (this.originalOptionSelector) {
      this.originalOptionSelector.insertAdjacentElement("afterend", this);
    }
  }

  buildOriginalOptionSelector() {
    const productTitle = document.querySelector(".block-product-title h1").innerHTML;
    const productPrice = document.querySelector(".block-product-price [data-price-formatted] > div.d-none span:not(.visually-hidden)").innerHTML;
    const headerMarkup = `
      <div class="gh146__option-header">
        <span class="option-header__title">${productTitle}</span>
        <span class="option-header__price">${productPrice}</span>
      </div>`
    const productSubtitle = `<span class="gh146__product-subtitle">${document.querySelector(".product-subtitle p").innerHTML}</span>`;

    this.originalOptionSelector.insertAdjacentHTML("afterbegin", headerMarkup);
    this.originalOptionSelector.querySelector("#variant-select").insertAdjacentHTML("beforebegin", productSubtitle);

    this.originalOptionSelector.classList.add("gh146-original-option-selector");
    this.originalOptionSelector.classList.add("open");
  }

  updateOrigianlPriceOnVariantChange() {
    const targetNode = document.querySelector(".block-product-price [data-rerender-on-variant-change]");
    const config = { attributes: true, childList: true, subtree: true };

    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.type === "childList") {
          const productPrice = document.querySelector(".block-product-price [data-price-formatted] > div.d-none span:not(.visually-hidden)").innerHTML;
          this.originalOptionSelector.querySelector(".option-header__price").innerHTML = productPrice;
        }
      }
    };

    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  }

  upsellSelectHandler() {
    this.upsellContainer.addEventListener("click", () => {
      if (!this.upsellContainer.classList.contains("open")) {
        this.upsellContainer.classList.add("open");
        this.originalOptionSelector.classList.remove("open");

        // update variant
        this.originalVariantIdElement.value = this.upsellVariantId;

        // update atc
        const atcEnable = this.upsellProductJson.variants.find(variant => variant.id === parseInt(this.upsellVariantId)).available;
        this.atcBtn.disabled = !atcEnable;
        atcEnable ? this.atcBtn.querySelector("span").innerHTML = "Add to cart" : this.atcBtn.querySelector("span").innerHTML = "Sold out";
      }
    })

    this.originalOptionSelector.addEventListener("click", () => {
      if (!this.originalOptionSelector.classList.contains("open")) {
        this.upsellContainer.classList.remove("open");
        this.originalOptionSelector.classList.add("open");

        // update variant
        this.originalVariantIdElement.value = this.originalVariantId;

        // update atc
        const atcEnable = this.originalProductJson.variants.find(variant => variant.id === parseInt(this.originalVariantId)).available;
        this.atcBtn.disabled = !atcEnable;
        atcEnable ? this.atcBtn.querySelector("span").innerHTML = "Add to cart" : this.atcBtn.querySelector("span").innerHTML = "Sold out";
      }
    })
  }

  optionInputClickHandler() {
    if (!this.productOptions) {
      return;
    }
    
    this.productOptions.forEach(input => {
      input.addEventListener("change", (e) => {
        e.preventDefault();
        const selectedOptionName = [...this.querySelectorAll("input:checked")].map(i => i.value).join(" / ");
        const selectedVariant = this.upsellProductJson.variants.find(variant => variant.title === selectedOptionName);
        const selectedVariantOption = this.selectOption.querySelector(`option[value="${selectedVariant.id}"]`);
        const selectedOptionLabel = e.target.closest(".product-options__option").querySelector(".option__title span");
        
        // update inner elements
        this.upsellVariantId = selectedVariant.id;
        this.originalVariantIdElement.value = selectedVariant.id;
        this.regularPrice.innerHTML = selectedVariantOption.dataset.price;
        this.comparePrice.innerHTML = selectedVariantOption.dataset.comparePrice ? selectedVariantOption.dataset.comparePrice : "";
        selectedOptionLabel.innerHTML = e.target.value;

        // update atc
        selectedVariant.available ? this.atcBtn.disabled = false : this.atcBtn.disabled = true;
        selectedVariant.available ? this.atcBtn.querySelector("span").innerHTML = "Add to cart" : this.atcBtn.querySelector("span").innerHTML = "Sold out";
      })
    })
  }

  variantChangeListener() {
    this.productContainer.addEventListener("variant:changed", (e) => {
      this.originalVariantId = e.detail.variant.id;
    })
  }
}

customElements.define("product-upsell", ProductUpsellPDP);